import Formatter from "../../Data/Domain/Formatter";
import Contact from "./Contact";

class Project {
  constructor({
    _id,
    latitude,
    longitude,
    ton_price,
    images,
    co2Goal,
    comercial_name,
    contacts = [],
    hash,
    publicKey,
    secretKey,
    is_private,
    enabled,
    area,
    biomass,
    co2_annual_estimated,
    contract_start_date,
    contract_end_date,
    region,
    volume,
    ton_co2_issued,
    province,
    data = {},
    info = {},
    impacts = [],
    sdgs = [],
    internal_code,
    show_without_purchase,
    is_available_for_nft,
    is_available_for_sbt,
    is_available_for_egrn,
    country_code,
    method,
    url_external_info,
    fee_egrn,
    forwards_equivalent,
    forwards_minimum,
    forwards_value,
    forwards_price,
    version,
  }) {
    this.id = _id;
    this.latitude = latitude;
    this.longitude = longitude;
    this.ton_price = ton_price;
    this.images = images;
    this.co2Goal = co2Goal;
    this.comercial_name = comercial_name;
    // this.contacts = contacts;
    // Todo: Llamar al método mencionado abajo
    this.contacts = this.setContacts(contacts);
    this.hash = hash;
    this.publicKey = publicKey;
    this.secretKey = secretKey;
    this.is_private = is_private;
    this.enabled = enabled;
    this.area = area;
    this.biomass = biomass;
    this.co2_annual_estimated = co2_annual_estimated;
    this.contract_start_date = contract_start_date;
    this.contract_end_date = contract_end_date;
    this.region = region;
    this.volume = volume;
    this.ton_co2_issued = this.tonCo2Issued(ton_co2_issued);
    this.province = province;
    this.data = data;
    this.info = info;
    this.impacts = impacts;
    this.sdgs = sdgs;
    this.internal_code = internal_code;
    this.show_without_purchase = show_without_purchase;
    this.is_available_for_nft = is_available_for_nft;
    this.is_available_for_sbt = is_available_for_sbt;
    this.is_available_for_egrn = is_available_for_egrn;
    this.country_code = country_code;
    this.method = method;
    this.url_external_info = url_external_info;
    this.fee_egrn = fee_egrn;
    this.forwards_equivalent = forwards_equivalent;
    this.forwards_minimum = forwards_minimum;
    this.forwards_value = forwards_value;
    this.forwards_price = forwards_price;
    this.version = version;
  }

  /* Todo: un método que basado en los contactos de la BD convierta a la clase Contact
    Recorrer contacts y por cada posición: new Contact(contact)
  */
  setContacts(contacts) {
    return contacts.map((contact) => new Contact(contact));
  }
  get mainImage() {
    const [
      main_image = {
        url: "https://cdn.impactinit.com/resizenp/600x600/x@7c62feb0ce/smss53/smsimg27/pv1000/isignstockcontributors/iss_2756_00053.jpg",
      },
    ] = this.images;
    return main_image.url;
  }

  get projectNameForSearcher() {
    return this.info?.en?.name || "";
  }

  get tonPrice() {
    return `${Formatter.round(this.ton_price / 100)} USD`;
  }

  get statusValue() {
    return this.enabled === true ? "Activo" : "Desactivado";
  }

  get privateValue() {
    return this.is_private === true ? "Privado" : "Publico";
  }

  get infos() {
    const { info } = this.info;
    return info;
  }
  get projectName() {
    return this.info?.en?.name?.toUpperCase() || "";
  }
  get projectType() {
    return this.info?.en?.project_type || "";
  }
  set availableBonds(available_bonds) {
    this.data = available_bonds;
  }

  get countryValue() {
    return this.info?.en?.country || "";
  }

  tonCo2Issued(ton_co2_issued) {
    return ton_co2_issued;
  }

  dataAvailableBonds() {
    return this.data.available_bonds;
  }
  toUpdate() {
    return { project_name: this.project_name };
  }

  get availableBonds() {
    return this.is_private ? this.co2Goal : this.dataAvailableBonds();
  }
}
export default Project;
